import { formatMoney } from "utils";

export const defaultValues = {
  amount: 0,
  accountName: "",
  detail: "",
  phone: "",
  date: new Date(),
  attachment: { loading: false, file: null, url: "" },
  notify: false,
  CashorCredit: false
};

const MAX_AMOUNT = 10000000;
export const validateAmount = (value) => {
  const num = Number(value);
  if (value === "" || isNaN(num) || num === 0) {
    return "Amount is required";
  } else if (Math.abs(num) >= MAX_AMOUNT) {
    return `Please enter an amount less than ${formatMoney(MAX_AMOUNT)}`;
  }
  return true;
};

export const validateNotify = (value, accountName, phone) => {
  if (!value) return true;
  if (!accountName) {
    return "Select an account to notify"
  }
  if (!phone) {
    return "Account does not have a phone number";
  }
  return true;
};